import { ROUTE_PATHS_TO_PATH_DOMAIN_MAP_VALUE } from 'modules/routes/constants/index.cjs'

export default function getDomainMapValueFromPathRouteUtil (pathname) {
  if (!ROUTE_PATHS_TO_PATH_DOMAIN_MAP_VALUE.find(path => pathname.includes(path))) {
    return
  }
  return pathname.split('/')[1]
}
